import { VendorTypeEnum } from "@finway-group/shared/lib/models"
import { Form } from "antd"
import { t } from "i18next"
import React, { useEffect } from "react"
import { FilterFormProps } from "~Components/filter/filterTypes"
import { VendorSelect } from "~Components/forms/expenseForm/commonInputFields/VendorSelect"
import { CollapseWrapper } from "~Shared/wrapper/collapse.wrapper"

export interface PurchaseOrderSelectionFilterFormValues {
    vendor?: string
}

export const PurchaseOrderSelectionFilterForm = ({ formInstance, filters, onFilter }: FilterFormProps<PurchaseOrderSelectionFilterFormValues>) => {
    useEffect(() => {
        formInstance.resetFields()
    }, [filters])

    return (
        <Form id="purchaseOrderSelectionFilterForm" className="form--filter" form={formInstance} onFinish={onFilter}>
            <CollapseWrapper keyCode="" header={t("label:vendor")} isCollapse isActive={!!filters.vendor}>
                <VendorSelect
                    shouldShowOnlyVerifiedVendors={false}
                    shouldRenderSelectDropdown={false}
                    selectedVendorType={VendorTypeEnum.VENDOR}
                    selectedCreditorId={filters.vendor}
                    formProps={{ name: "vendor", form: formInstance }}
                />
            </CollapseWrapper>
        </Form>
    )
}
